module.exports = __webpack_public_path__ + "img/3.478bd388.jpg";